export default __webpack_public_path__ + "static/media/bid.61a9d48d.svg";